import { Injectable } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { IRawComponent } from 'projects/common/src/app/interfaces/remote-models';
import { map } from 'rxjs/operators';
import { CommunicationSecurityService } from 'src/app/services/communication';
import { environment } from 'src/environments/environment';
import { TargetAppService, UserDataService } from '../../core/services/parameter';
import { IDashboardConfiguration, IWidgetConfiguration } from '../../widget/interfaces/widget';
import { ComponentWidgetProviderService } from './component-widget-provider.service';

@Injectable({
  providedIn: 'root',
})
export class WidgetProviderService extends Logger {
  public componentCollection: IDashboardConfiguration[];
  private securityBaseUrl: string;
  private endpoint: string;

  constructor(
    private communication: CommunicationSecurityService,
    private application: TargetAppService,
    private userData: UserDataService,
    private componentProvider: ComponentWidgetProviderService,
  ) {
    super();
    this.securityBaseUrl = environment.securityBasePath;
    this.endpoint = `${this.securityBaseUrl}/component/getusercomponents`;
  }

  /**
   * Get the configuration
   *
   * @param config config name
   */
  public getConfiguration(config: string): Promise<IDashboardConfiguration> {
    const userId = this.userData.userId();
    const appId = this.application.getId();

    return new Promise((resolve, reject) => {
      this.communication
        .get(this.endpoint, { userId })
        .pipe(map((value: IRawComponent[]) => value.filter((x) => x.appId === appId)))
        .subscribe(
          (result: IRawComponent[]) => {
            const widgets: IWidgetConfiguration[] = result.map((element) => this.parse(element));
            resolve({
              name: config,
              unit: null,
              value: null,
              widgets,
            } as IDashboardConfiguration);
          },
          (error: any) => {
            this.error(`no_configuration_available_for`, `${config}`);
            reject(error);
          },
        );
    });
  }

  /**
   * Converts rawdata component to system component
   *
   * @param value rawdata component
   */
  private parse(value: IRawComponent): IWidgetConfiguration {
    const buttonList = [
      {
        icon: value.exportIcon,
        source: value.endpointExport,
        class: value.exportClass,
        hasDownload: value.hasDownload,
        hasTable: value.hasTable,
        hasChangeView: value.hasChangeView,
      },
    ];

    return {
      hostPresentationClass: value.hostClass,
      componentData: {
        title: value.visibleName,
        source: `${environment.serverBasePath}/${value.endpoint}`,
        icon: value.icon,
        class: value.class,
        timeout: value.timeout,
        delay: value.delay,
        export: buttonList,
        objCode: value.objCode,
        componentId: value.componentId,
      },
      rawComponent: value,
      presentationType: value.presentationType,
      component: this.componentProvider.get(value.componentType),
      order: value.orderElement,
    };
  }
}
